var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('van-dialog',{attrs:{"title":"分享","close-on-click-overlay":true,"show-confirm-button":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{staticClass:"share-img",attrs:{"src":_vm.qrimg}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }